/* The bag — behavior for the drawer, the phone sheet, and the /cart page.
   Design: "The Bag — Cart Boards" (Claude Design, 2026-08-23).
   Data source: Shopify Ajax cart; every mutation re-renders through the
   Section Rendering API so Liquid stays the single renderer. The
   <cart-drawer> element keeps Dawn's product-form.js contract
   (getSectionsToRender / renderContents / setActiveElement) so PDP adds
   open the drawer with no Dawn edits. */
(function () {
  'use strict';
  if (window.__srrcoBagJs) return;
  window.__srrcoBagJs = true;

  var DRAWER_SECTION = 'm-bag-drawer';
  var PAGE_SECTION = 'm-bag-page';
  var GC_KEY = 'srrco_web_gc_v1';
  var FLY_KEY = 'srrco_bag_flew_v1';
  /* the balance call rides the theme's api_base switch like every other
     unified call (window.SRRCoApi from m-api-base.liquid); the old raw fly
     hostname stays as the fallback for pages without the head snippet */
  function giftbridgeBalanceUrl() {
    return ((window.SRRCoApi && window.SRRCoApi.base) || 'https://srrco-backend.fly.dev') + '/giftbridge/balance';
  }
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var busy = false;
  var lastAction = null;

  function root() { return document.querySelector('[data-bag-root]'); }
  function panel() { return document.querySelector('[data-bag-panel]'); }
  function pageInner() { return document.querySelector('[data-bag-page-inner]'); }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  /* ---------- section refresh plumbing ---------- */
  function sectionIds() {
    var ids = [DRAWER_SECTION];
    if (pageInner()) ids.push(PAGE_SECTION);
    return ids;
  }
  var FOCUS_MARKS = ['data-bag-qty', 'data-bag-remove', 'data-bag-cadence', 'data-bag-subscribe', 'data-bag-onetime', 'data-bag-code-apply', 'data-bag-code', 'data-bag-close', 'data-bag-gift-toggle', 'data-bag-chip-remove', 'data-bag-gift-edit', 'data-bag-shipon-toggle'];
  function captureFocus() {
    var act = document.activeElement;
    if (!act || !act.closest || !act.closest('[data-bag-drawer-inner], [data-bag-page-inner]')) return null;
    var line = act.closest('[data-bag-line]');
    for (var i = 0; i < FOCUS_MARKS.length; i++) {
      if (act.hasAttribute(FOCUS_MARKS[i])) {
        var v = act.getAttribute(FOCUS_MARKS[i]);
        return {
          surface: act.closest('[data-bag-drawer-inner]') ? '[data-bag-drawer-inner]' : '[data-bag-page-inner]',
          key: line ? line.getAttribute('data-bag-key') : null,
          sel: v ? '[' + FOCUS_MARKS[i] + '="' + v.replace(/"/g, '\\"') + '"]' : '[' + FOCUS_MARKS[i] + ']'
        };
      }
    }
    return null;
  }
  function restoreFocus(spot) {
    if (!spot) return;
    var surface = document.querySelector(spot.surface);
    if (!surface) return;
    var scope = spot.key ? surface.querySelector('[data-bag-line][data-bag-key="' + spot.key.replace(/"/g, '\\"') + '"]') : null;
    var el = (scope && scope.querySelector(spot.sel)) || surface.querySelector(spot.sel);
    if (el && el.focus) el.focus({ preventScroll: true });
  }
  function swapFromSections(sections) {
    if (!sections) return;
    var spot = captureFocus();
    if (sections[DRAWER_SECTION]) {
      var host = document.createElement('div');
      host.innerHTML = sections[DRAWER_SECTION];
      var fresh = host.querySelector('[data-bag-drawer-inner]');
      var cur = document.querySelector('[data-bag-drawer-inner]');
      if (fresh && cur) cur.replaceWith(fresh);
    }
    if (sections[PAGE_SECTION]) {
      var host2 = document.createElement('div');
      host2.innerHTML = sections[PAGE_SECTION];
      var fresh2 = host2.querySelector('[data-bag-page-inner]');
      var cur2 = pageInner();
      if (fresh2 && cur2) cur2.replaceWith(fresh2);
    }
    restoreFocus(spot);
    poMixCheck();
    syncHeaderCount();
    paintGiftCardChip();
    paintCodeMsg();
    paintGiftCounters();
    scrubStaleShip();
    scrubRuleShip();
    paintShipRows();
    paintEstimate();
    paintDrawerRewards();
    paintReservedChips();
    paintCreditChips();
    /* unified bag: re-inject the cafe rail (the swap wiped the slots) and
       mirror this cart state into the bag's retail lines */
    if (window.SRRCoBag) {
      try { window.SRRCoBag.paint(); } catch (e) {}
      mirrorSoon();
    }
  }
  /* ---------- estimated shipping (real rates, default address) ---------- */
  var estCache = {};
  var estShipCents = null;   /* last live shipping estimate; null = unknown */
  var creditOnCents = 0;     /* the balance the member switched on; 0 = off */
  /* one painter for the estimated total so shipping and credit never
     overwrite each other (owner 9/14: a checked credit must show as a
     reduction on the estimated total) */
  function paintGrand() {
    var g = document.querySelector('[data-bag-est]');
    var grand = document.querySelector('[data-bag-grand]');
    if (!g || !grand) return;
    var total = parseInt(g.getAttribute('data-bag-total-cents') || '0', 10);
    var base = total + (estShipCents || 0);
    var use = Math.min(creditOnCents, base);
    var row = document.querySelector('[data-bag-credit-trow]');
    var num = document.querySelector('[data-bag-credit-tnum]');
    if (row) row.hidden = !(use > 0);
    if (num) num.textContent = '\u2212' + money(use);
    grand.textContent = money(base - use);
  }
  function estZip() {
    try { var z = localStorage.getItem('srrco_est_zip'); if (z) return JSON.parse(z); } catch (e) {}
    return null;
  }
  function paintEstimate() {
    var g = document.querySelector('[data-bag-est]');
    if (!g) return;
    var saved = estZip();
    var zip = (saved && saved.zip) || g.getAttribute('data-bag-est-zip');
    var country = (saved && saved.country) || g.getAttribute('data-bag-est-country') || 'US';
    var province = (saved && saved.province) || g.getAttribute('data-bag-est-province') || '';
    var total = parseInt(g.getAttribute('data-bag-total-cents') || '0', 10);
    var ask = document.querySelector('[data-bag-est-ask]');
    estShipCents = null;
    if (!zip || !total) {
      /* never guess a location — offer the ZIP prompt instead */
      if (ask && total) ask.hidden = false;
      paintGrand();
      return;
    }
    if (ask) ask.hidden = true;
    var key = zip + ':' + total;
    var apply = function (cents) {
      var row = document.querySelector('[data-bag-est-shiprow]');
      var val = document.querySelector('[data-bag-est-ship]');
      var grand = document.querySelector('[data-bag-grand]');
      var fine = document.querySelector('[data-bag-est-fine]');
      if (!row || !val || !grand) return;
      row.hidden = false;
      val.textContent = cents === 0 ? 'Free' : money(cents);
      estShipCents = cents;
      paintGrand();
      if (fine) fine.textContent = '';
    };
    if (estCache[key] === null) { if (ask) ask.hidden = false; paintGrand(); return; }
    if (typeof estCache[key] === 'number') { apply(estCache[key]); return; }
    var q = 'shipping_address%5Bzip%5D=' + encodeURIComponent(zip)
      + '&shipping_address%5Bcountry%5D=' + encodeURIComponent(country)
      + '&shipping_address%5Bprovince%5D=' + encodeURIComponent(province);
    fetch('/cart/shipping_rates.json?' + q)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var rates = (d && d.shipping_rates) || [];
        if (!rates.length) { estCache[key] = null; if (ask) ask.hidden = false; return; }
        var cheapest = rates.reduce(function (a, b) { return parseFloat(a.price) <= parseFloat(b.price) ? a : b; });
        var cents = Math.round(parseFloat(cheapest.price) * 100);
        estCache[key] = cents;
        apply(cents);
      })
      .catch(function () { estCache[key] = null; });
  }

  /* ---------- Roastery Rewards checkboxes (cafe checkout pattern) ---------- */
  var rwMeCache = null;
  var rwBusy = false;
  var rwPopOpen = false;
  var rwCoffees = { sample: null, bag: null };
  var rwPickKind = null; /* 'sample'|'bag' — the coffee list replaces the chooser */
  var rwPendingKey = null; /* the reward to reserve once a coffee is chosen */
  var rwPickCoffee = null; /* the 12 oz coffee waiting on its grind */
  function loadRwCoffees(kind) {
    if (rwCoffees[kind]) return Promise.resolve(rwCoffees[kind]);
    var url = kind === 'sample' ? '/products.json?limit=250' : '/collections/coffee/products.json?limit=250';
    return fetch(url).then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (d) {
      var out = [];
      (d.products || []).forEach(function (pr) {
        if (kind === 'sample') {
          if (/starter\s*pack/i.test(pr.title || '')) return;
          var vs = pr.variants || [];
          var all4 = vs.length && vs.every(function (v) { return /4\s*oz/i.test(String(v.option1 || '')); });
          if (!all4) return;
          var v0 = vs.filter(function (v) { return /whole/i.test(String(v.option2 || v.title || '')); })[0] || vs[0];
          out.push({ id: v0.id, name: pr.title, price: v0.price });
        } else {
          (pr.variants || []).forEach(function (v) {
            if (!/12\s*oz/i.test(String(v.option1 || v.title || ''))) return;
            if (!/whole/i.test(String(v.option2 || v.title || ''))) return;
            /* owner 10/30: the free 12 oz bag can come ground (drip grind, no
               Ground-for pick) when the coffee has a 12 oz Ground variant */
            var gv = (pr.variants || []).filter(function (w) {
              var wg = String(w.option2 || w.title || '');
              return /12\s*oz/i.test(String(w.option1 || w.title || '')) && /ground/i.test(wg) && !/whole/i.test(wg) && w.available !== false;
            })[0];
            out.push({ id: v.id, name: pr.title, price: v.price, groundId: gv ? gv.id : null, groundPrice: gv ? gv.price : null });
          });
        }
      });
      rwCoffees[kind] = out.slice(0, 40);
      return rwCoffees[kind];
    }).catch(function () { rwCoffees[kind] = []; return rwCoffees[kind]; });
  }
  function paintRwCoffees() {
    var box = document.querySelector('[data-bag-rewards]');
    if (!box || !rwPickKind) return;
    var list = box.querySelector('[data-bag-rewards-list]');
    var pop = box.querySelector('[data-bag-rwpop]');
    if (!list || !pop) return;
    pop.hidden = false;
    if (rwPickCoffee) {
      var picked = rwPickCoffee;
      var grindRow = function (id, label, price) {
        return '<button type="button" class="m-bag__rwchoice" data-bag-rw-coffee="' + id + '"><span>' + label + '</span><span class="m-bag__rwpts"><s>$' + esc(String(price)) + '</s> free</span></button>';
      };
      list.innerHTML = '<div class="m-bag__rwgroup"><span class="m-bag__kicker">Pick the grind</span><span class="m-bag__rwgroup-sub">' + esc(picked.name) + '</span></div>'
        + grindRow(picked.id, 'Whole Bean', picked.price)
        + grindRow(picked.groundId, 'Ground (drip)', picked.groundPrice)
        + '<button type="button" class="m-bag__textlink m-bag__rwback" data-bag-rw-grind-back>Back to the coffees</button>';
      return;
    }
    var coffees = rwCoffees[rwPickKind];
    list.innerHTML = '<div class="m-bag__rwgroup"><span class="m-bag__kicker">Pick the coffee</span><span class="m-bag__rwgroup-sub">It rides this order free.</span></div>'
      + (coffees === null
        ? '<div class="m-bag__fine">Loading the coffees&hellip;</div>'
        : coffees.map(function (co) {
            return '<button type="button" class="m-bag__rwchoice" ' + (co.groundId ? 'data-bag-rw-grind-of' : 'data-bag-rw-coffee') + '="' + co.id + '"><span>' + esc(co.name) + '</span><span class="m-bag__rwpts"><s>$' + esc(String(co.price)) + '</s> free</span></button>';
          }).join(''));
  }
  var RW_KINDS = { free_shipping: 1, product: 1, sample: 1, bag: 1, credit: 1 };
  function rwHeaders(box) {
    return {
      'X-SRRCo-Customer': box.getAttribute('data-cid') || '',
      'X-SRRCo-Email': box.getAttribute('data-email') || '',
      'X-SRRCo-Sig': box.getAttribute('data-sig') || ''
    };
  }
  function paintDrawerRewards() {
    var box = document.querySelector('[data-bag-rewards]');
    if (!box) return;
    var fill = function (me) {
      var list = box.querySelector('[data-bag-rewards-list]');
      if (!list) return;
      /* the server builds this list against the COMBINED balance — trust it */
      var rewards = ((me && me.rewards) || []).filter(function (r) { return RW_KINDS[r.kind]; });
      box.hidden = false;
      var line = box.querySelector('[data-bag-rw-open]');
      if (line) line.closest('.m-bag__rwline').hidden = !rewards.length;
      var pop = box.querySelector('[data-bag-rwpop]');
      if (pop) pop.hidden = !rwPopOpen;
      if (rwPickKind) { paintRwCoffees(); return; }
      var row = function (r) {
        var worth = r.kind === 'free_shipping' ? 'this order ships free'
          : r.kind === 'credit' ? ''
            : (r.amountCents != null ? 'worth ' + money(Number(r.amountCents)) : '');
        return '<button type="button" class="m-bag__rwchoice" data-bag-rw-key="' + esc(r.key) + '" data-bag-rw-points="' + Number(r.points || 0) + '"'
          + (r.all ? ' data-bag-rw-all="1"' : '') + (r.kind === 'credit' ? ' data-bag-rw-oneway="1"' : '')
          + (rwBusy ? ' disabled' : '') + '><span data-bag-rw-label>' + esc(r.label || r.key) + '</span><span class="m-bag__rwpts">' + Number(r.points || 0).toLocaleString()
          + ' pts' + (worth ? ' &middot; ' + esc(worth) : '') + '</span></button>';
      };
      var codes = rewards.filter(function (r) { return r.kind !== 'credit'; });
      var credits = rewards.filter(function (r) { return r.kind === 'credit'; });
      list.innerHTML = codes.map(row).join('')
        + (credits.length
          ? '<div class="m-bag__rwgroup"><span class="m-bag__kicker">Points to credit</span>'
            + '</div>'
            + credits.map(row).join('')
          : '');
    };
    if (rwMeCache) { fill(rwMeCache); paintCredit(); return; }
    fetch(box.getAttribute('data-api') + '/shop/rewards/me', { credentials: 'include', headers: rwHeaders(box) })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (me) { if (me) { rwMeCache = me; fill(me); paintCredit(); } })
      .catch(function () {});
    paintCredit();
  }
  /* credit checkbox: the member's own gift card, staged for the checkout
     gift-card box (Shopify can't take it earlier). Session cookie only. */
  var creditCards = null;
  var creditAuth = 0;
  var creditPrefLoaded = false;
  function creditFaceCard(owned) { return owned.filter(function (cd) { return cd.primary; })[0] || null; }
  function paintCredit() {
    var row = document.querySelector('[data-bag-credit-row]');
    if (!row) return;
    var sw = row.querySelector('[data-bag-credit-toggle]');
    var note = row.querySelector('[data-bag-credit-note]');
    var label = row.querySelector('[data-bag-credit-label]');
    var cb = row.querySelector('[data-bag-credit]');
    var setSw = function (on, enabled) {
      if (sw) { sw.setAttribute('aria-checked', on ? 'true' : 'false'); sw.disabled = !enabled; }
      if (cb) cb.checked = !!on;
      row.classList.toggle('is-on', !!on);
    };
    var fill = function () {
      row.hidden = false;
      var signedOut = creditAuth === 401 || creditAuth === 403;
      var owned = (creditCards || []).filter(function (cd) { return cd.balanceCents > 0; });
      /* no account session, but the Shopify login is proven to /shop/rewards/me by the
         theme signature — its giftCard/storeCredit is the same balance (owner 9/14:
         "how am I not logged in if you see my Punkin's bar?") */
      var me = rwMeCache;
      if (signedOut && !owned.length && me) {
        var viaMe = [];
        if (me.giftCard && me.giftCard.balanceCents > 0) viaMe.push({ last4: me.giftCard.last4, balanceCents: me.giftCard.balanceCents, primary: true, viaRewards: true });
        else if (me.storeCredit && me.storeCredit.balanceCents > 0) viaMe.push({ last4: '', balanceCents: me.storeCredit.balanceCents, primary: true, viaRewards: true });
        owned = viaMe;
      }
      creditOnCents = 0;
      if (signedOut && !owned.length) {
        row.setAttribute('data-bag-credit-state', 'signed-out');
        if (label) label.textContent = 'Use my credit';
        setSw(false, false);
        if (note) note.innerHTML = (me ? 'No credit on your card yet. ' : 'Sign in to see your credit. ') + '<a href="/pages/to-go?view=signin&return_to=' + encodeURIComponent(location.pathname + location.search) + '">Sign in</a>';
        paintGrand();
        return;
      }
      if (!owned.length) {
        row.setAttribute('data-bag-credit-state', 'none');
        if (label) label.textContent = 'Use my credit';
        setSw(false, false);
        if (note) note.textContent = 'No credit on your card yet. Points turn into credit under Choose.';
        paintGrand();
        return;
      }
      var total = owned.reduce(function (s2, cd) { return s2 + cd.balanceCents; }, 0);
      if (label) label.textContent = 'Use my ' + money(total) + ' credit';
      var scLine = document.querySelector('[data-bag-storecredit]');
      if (scLine) scLine.hidden = true;
      var face = creditFaceCard(owned);
      var on = !!(cb && cb.checked);
      if (!creditPrefLoaded) {
        creditPrefLoaded = true;
        var pref = null;
        try { pref = sessionStorage.getItem('srrco_credit_on_v1'); } catch (e) {}
        /* never pre-checked (owner 9/14) — the member switches it on */
        on = pref === '1';
      }
      row.setAttribute('data-bag-credit-state', on ? 'on' : 'off');
      setSw(on, true);
      creditOnCents = on ? total : 0;
      paintGrand();
      if (!note) return;
      if (on && face) {
        var g0 = document.querySelector('[data-bag-est]');
        var cartBase = parseInt((g0 && g0.getAttribute('data-bag-total-cents')) || '0', 10) + (estShipCents || 0);
        note.textContent = total >= cartBase && cartBase > 0
          ? 'At checkout, tick Apply store credit under Payment. It covers your final total and the rest stays on your card.'
          : 'At checkout, tick Apply store credit under Payment. It comes off your final total.';
      } else if (on && creditGan) {
        var c0 = owned[0];
        note.innerHTML = 'Gift card &middot;&middot;&middot;&middot; ' + esc(c0.last4)
          + ' goes in the gift card box at checkout. <button type="button" class="m-bag__textlink" data-bag-credit-copy>Copy the number</button>';
      } else if (on && signedOut) {
        note.innerHTML = 'Sign in to get your card number for checkout. <a href="/pages/to-go?view=signin&return_to=' + encodeURIComponent(location.pathname + location.search) + '">Sign in</a>';
      } else if (on) {
        note.textContent = 'Getting your card number…';
      } else {
        note.textContent = '';
      }
    };
    if (creditCards) { fill(); return; }
    if (creditAuth) { fill(); return; }
    var box = document.querySelector('[data-bag-rewards]');
    if (!box) return;
    fetch(box.getAttribute('data-api') + '/identity/giftcards', { credentials: 'include' })
      .then(function (r) { creditAuth = r.status; return r.ok ? r.json() : null; })
      .then(function (d) { creditCards = (d && d.cards) || []; fill(); })
      .catch(function () { creditCards = []; fill(); });
  }
  var creditGan = null;
  function creditToggle(input) {
    var owned = (creditCards || []).filter(function (cd) { return cd.balanceCents > 0; });
    try { sessionStorage.setItem('srrco_credit_on_v1', input.checked ? '1' : '0'); } catch (e) {}
    if (!input.checked || !owned.length) { creditGan = null; paintCredit(); return; }
    /* store-credit face: the primary card IS Shopify store credit — nothing to reveal or type */
    if (creditFaceCard(owned)) { creditGan = null; paintCredit(); return; }
    var primary = owned.filter(function (cd) { return cd.primary; })[0] || owned[0];
    var box = document.querySelector('[data-bag-rewards]');
    fetch(box.getAttribute('data-api') + '/identity/giftcards/reveal', {
      method: 'POST', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: primary.id })
    }).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (d && d.gan) { creditGan = d.gan; }
        else { input.checked = false; }
        paintCredit();
      })
      .catch(function () { input.checked = false; paintCredit(); });
  }
  /* reserved picks whose codes Shopify hasn't applied yet (the free-item
     codes bite only when their item is in the cart) still need a face:
     a chip with the add-the-item hint and a working X */
  /* X on a free-coffee product line = X on the reward: cancel the
     reservation, drop its code, say nothing was spent */
  function releaseRewardForLine(lineKey) {
    var vpart = parseInt(String(lineKey).split(':')[0], 10);
    if (!vpart) return;
    var map;
    try { map = JSON.parse(sessionStorage.getItem('srrco_rw_reserved') || '{}'); } catch (e) { return; }
    Object.keys(map).forEach(function (code) {
      var entry = map[code];
      if (!entry || typeof entry !== 'object' || entry.v !== vpart) return;
      delete map[code];
      try { sessionStorage.setItem('srrco_rw_reserved', JSON.stringify(map)); } catch (e) {}
      removeCode(code);
      var rbox = document.querySelector('[data-bag-rewards]');
      if (rbox && entry.id) {
        fetch(rbox.getAttribute('data-api') + '/shop/rewards/redemption/cancel', {
          method: 'POST', credentials: 'include',
          headers: Object.assign({ 'Content-Type': 'application/json' }, rwHeaders(rbox)),
          body: JSON.stringify({ id: entry.id })
        }).then(function () { rwMeCache = null; paintDrawerRewards(); }).catch(function () {});
      }
      toast('Reward removed — nothing was spent');
    });
  }
  function paintCreditChips() {
    var wrap = document.querySelector('[data-bag-chips]');
    if (!wrap) return;
    wrap.querySelectorAll('[data-bag-credit-chip]').forEach(function (n) { n.remove(); });
    var cmap;
    try { cmap = JSON.parse(sessionStorage.getItem('srrco_rw_credit') || '{}'); } catch (e) { return; }
    Object.keys(cmap).forEach(function (rid) {
      var div = document.createElement('div');
      div.className = 'm-bag__chip';
      div.setAttribute('data-bag-credit-chip', rid);
      var faceNow = !!creditFaceCard((creditCards || []).filter(function (cd) { return cd.balanceCents > 0; }));
      div.innerHTML = '<div class="m-bag__chip-t"><strong>' + money(Number(cmap[rid])) + ' to your gift card</strong><br><span class="m-bag__chip-sub">' + (faceNow ? 'Spends at checkout — tick Apply store credit under Payment.' : 'Spends at checkout through the gift card box.') + '</span></div>'
        + '<button type="button" class="m-bag__chip-x" data-bag-credit-undo="' + esc(rid) + '" aria-label="Un-convert this credit">&times;</button>';
      wrap.appendChild(div);
    });
  }
  function paintReservedChips() {
    var wrap = document.querySelector('[data-bag-chips]');
    if (!wrap) return;
    wrap.querySelectorAll('[data-bag-reserved-chip]').forEach(function (n) { n.remove(); });
    var map;
    try { map = JSON.parse(sessionStorage.getItem('srrco_rw_reserved') || '{}'); } catch (e) { return; }
    var applied = appliedCodes().map(function (x) { return x.toUpperCase(); });
    var visible = [...wrap.querySelectorAll('[data-bag-chip]')].map(function (n) { return String(n.getAttribute('data-bag-chip')).toUpperCase(); });
    Object.keys(map).forEach(function (code) {
      var entry = map[code];
      if (entry && typeof entry === 'object' && entry.v) return; /* product-backed: the line is the face */
      if (applied.indexOf(code) !== -1 || visible.indexOf(code) !== -1) return;
      var hint = 'Applies at checkout.';
      var div = document.createElement('div');
      div.className = 'm-bag__chip';
      div.setAttribute('data-bag-reserved-chip', '1');
      div.innerHTML = '<div class="m-bag__chip-t"><strong>' + esc(code) + ' &middot; reserved</strong><br><span class="m-bag__chip-sub">' + hint + ' No points spent until the order goes through.</span></div>'
        + '<button type="button" class="m-bag__chip-x" data-bag-chip-remove="' + esc(code) + '" aria-label="Remove ' + esc(code) + '">&times;</button>';
      wrap.appendChild(div);
    });
  }

  function redeemDrawerReward(btn) {
    if (rwBusy) return;
    rwBusy = true;
    btn.disabled = true;
    btn.classList.add('is-busy');
    var labelSpan = btn.querySelector('span');
    var oldLabel = labelSpan ? labelSpan.textContent : '';
    if (labelSpan) labelSpan.textContent = 'Adding\u2026';
    var box = document.querySelector('[data-bag-rewards]');
    var key = btn.getAttribute('data-bag-rw-key');
    /* defer marks a cart-origin pick: codes reserve until checkout, and
       nothing from the cart sends an email — the drawer is the receipt */
    var body = { key: key, defer: true };
    if (key.indexOf('credit') === 0) {
      /* tier keys arrive as credit:250 / credit:all — the redeem schema
         wants key 'credit' plus the amount */
      body.key = 'credit';
      if (key === 'credit:all' || btn.getAttribute('data-bag-rw-all')) body.all = true;
      else body.points = parseInt(btn.getAttribute('data-bag-rw-points') || '0', 10);
    }
    var optimisticId = null;
    if (body.key === 'credit' && !body.all) {
      /* instant: the chip and toast land NOW; the server confirms behind
         it and the chip retracts with an honest word if it could not */
      optimisticId = 'pending-' + Date.now();
      try {
        var ocm = JSON.parse(sessionStorage.getItem('srrco_rw_credit') || '{}');
        ocm[optimisticId] = body.points * 1.2; /* centsPerPoint display guess */
        sessionStorage.setItem('srrco_rw_credit', JSON.stringify(ocm));
      } catch (err) {}
      toast(money(Math.round(body.points * 1.2)) + ' heading to your gift card');
      paintCreditChips();
      rwBusy = false;
      btn.disabled = false;
      btn.classList.remove('is-busy');
      if (labelSpan) labelSpan.textContent = oldLabel;
    }
    fetch(box.getAttribute('data-api') + '/shop/rewards/redeem', {
      method: 'POST', credentials: 'include',
      headers: Object.assign({ 'Content-Type': 'application/json' }, rwHeaders(box)),
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok || !res.d || !res.d.redemption) throw new Error('redeem failed');
        rwMeCache = null;
        if (optimisticId) {
          /* swap the placeholder for the real redemption id + exact cents */
          try {
            var scm = JSON.parse(sessionStorage.getItem('srrco_rw_credit') || '{}');
            delete scm[optimisticId];
            scm[res.d.redemption.id] = Number(res.d.redemption.amountCents || 0);
            sessionStorage.setItem('srrco_rw_credit', JSON.stringify(scm));
          } catch (err) {}
          creditCards = null;
          paintCreditChips();
          paintCredit();
          rwBusy = false;
          return null;
        }
        if (res.d.redemption.code) {
          try {
            var map = JSON.parse(sessionStorage.getItem('srrco_rw_reserved') || '{}');
            map[res.d.redemption.code.toUpperCase()] = res.d.redemption.id;
            sessionStorage.setItem('srrco_rw_reserved', JSON.stringify(map));
          } catch (err) {}
          var all = appliedCodes();
          if (all.indexOf(res.d.redemption.code) === -1) all.push(res.d.redemption.code);
          /* the reservation ALREADY succeeded — a cart-apply hiccup is not
             a failure, the synthetic chip carries it from here */
          return mutate('/cart/update.js', { discount: all.join(',') }).catch(function () { return { ok: true }; });
        }
        /* credit: cash landed on the card, not the cart — restage the
           credit checkbox with the new balance */
        try {
          var cmap = JSON.parse(sessionStorage.getItem('srrco_rw_credit') || '{}');
          cmap[res.d.redemption.id] = Number(res.d.redemption.amountCents || 0);
          sessionStorage.setItem('srrco_rw_credit', JSON.stringify(cmap));
        } catch (err) {}
        creditCards = null;
        toast(money(Number(res.d.redemption.amountCents || 0)) + ' added to your gift card');
        paintCredit();
        return null;
      })
      .then(function (r2) {
        rwBusy = false;
        if (optimisticId) return; /* credit already painted, no refresh needed */
        if (r2 !== null && labelSpan) {
          toast('Reserved — it rides this order');
          /* code-only rewards: our chip IS the interface — repaint local,
             skip the full section round-trip */
          rwMeCache = null;
          paintReservedChips();
          paintDrawerRewards();
          return;
        }
        return refresh();
      })
      .catch(function () {
        rwBusy = false;
        btn.disabled = false;
        btn.classList.remove('is-busy');
        if (labelSpan) labelSpan.textContent = oldLabel;
        if (optimisticId) {
          /* retract the placeholder chip honestly */
          try {
            var rcm = JSON.parse(sessionStorage.getItem('srrco_rw_credit') || '{}');
            delete rcm[optimisticId];
            sessionStorage.setItem('srrco_rw_credit', JSON.stringify(rcm));
          } catch (err) {}
          paintCreditChips();
        }
        toast('That one did not go through — try again');
      });
  }
  window.SRRCoBagRefresh = function () { return refresh(); };
  /* first paint: the server-rendered drawer never goes through
     swapFromSections, so the estimate and rewards need a ready-time run */
  /* Shopify keeps discount codes on the cart even when nothing in it qualifies;
     they surface again at checkout. Drop the ones it reports as not applicable
     at every first paint (owner 2026-09-14: "why does WELCOME 10 keep appearing"). */
  function scrubStaleCodes() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var codes = (c && c.discount_codes) || [];
      if (!codes.length) return;
      var keep = codes.filter(function (dc) { return dc && dc.applicable; }).map(function (dc) { return dc.code; });
      if (keep.length === codes.length) return;
      mutate('/cart/update.js', { discount: keep.join(',') })
        .then(function (r3) { if (r3.ok) swapFromSections(r3.d.sections); })
        .catch(function () {});
    }).catch(function () {});
  }
  function paintExtras() { try { paintEstimate(); } catch (e) {} try { paintDrawerRewards(); } catch (e) {} try { paintReservedChips(); } catch (e) {} try { scrubStaleCodes(); } catch (e) {} try { paintCreditChips(); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paintExtras);
  else paintExtras();

  var mirrorTimer = null;
  function mirrorSoon() {
    if (!window.SRRCoBag || !window.SRRCoBag.reconcile) return;
    clearTimeout(mirrorTimer);
    mirrorTimer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart) return window.SRRCoBag.reconcile(cart); })
        .catch(function () {});
    }, 400);
  }
  function refresh() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sections: sectionIds(), sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (d) { swapFromSections(d.sections); return d; });
  }
  function mutate(url, body) {
    body.sections = sectionIds();
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (d) { return { ok: r.ok, status: r.status, d: d }; });
    });
  }
  function netFail(retryFn) {
    lastAction = retryFn;
    document.querySelectorAll('[data-bag-net]').forEach(function (n) { n.hidden = false; });
  }
  function netClear() {
    lastAction = null;
    document.querySelectorAll('[data-bag-net]').forEach(function (n) { n.hidden = true; });
  }
  function lineVeil(lineEl, on) {
    if (!lineEl) return;
    var v = lineEl.querySelector('.m-bag__l-veil');
    if (v) v.hidden = !on;
  }
  function syncHeaderCount() {
    var inner = document.querySelector('[data-bag-drawer-inner]') || pageInner();
    if (!inner) return;
    var n = parseInt(inner.getAttribute('data-bag-count') || '0', 10);
    /* the unified bag's cafe lines ride the same badge */
    if (window.SRRCoBag && window.SRRCoBag.cafeCount) { try { n += window.SRRCoBag.cafeCount(); } catch (e) {} }
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    document.querySelectorAll('[data-bag-glyph-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  /* ---------- open / close ---------- */
  var lastFocus = null;
  function isOpen() { var p = panel(); return p && !p.hidden; }
  function openDrawer() {
    var r = root(); var p = panel(); if (!r || !p) return;
    lastFocus = document.activeElement;
    document.querySelector('[data-bag-veil]').hidden = false;
    p.hidden = false;
    var arm = function () { r.classList.add('is-open'); };
    requestAnimationFrame(arm);
    setTimeout(arm, 30);
    document.body.classList.add('m-bag-open');
    var c = p.querySelector('[data-bag-close]');
    if (c) c.focus({ preventScroll: true });
  }
  function closeDrawer() {
    var r = root(); var p = panel(); if (!r || !p || p.hidden) return;
    r.classList.remove('is-open');
    document.body.classList.remove('m-bag-open');
    var done = function () {
      p.hidden = true;
      var v = document.querySelector('[data-bag-veil]'); if (v) v.hidden = true;
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    };
    if (reduced) done(); else setTimeout(done, 240);
  }

  /* ---------- toast + fly chip ---------- */
  var toastTimer = null;
  function toast(msg) {
    var t = document.querySelector('[data-bag-toast]');
    if (!t) return;
    t.innerHTML = '<span aria-hidden="true">✓</span> ' + esc(msg);
    t.hidden = false;
    t.classList.add('is-in');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      t.classList.remove('is-in');
      setTimeout(function () { t.hidden = true; }, 220);
    }, 1900);
  }
  function flyChip(imgUrl, fromEl) {
    if (reduced) return;
    try { if (sessionStorage.getItem(FLY_KEY)) return; sessionStorage.setItem(FLY_KEY, '1'); } catch (e) {}
    var target = document.querySelector('.mtop__cart, .mhead__cart');
    if (!target || !fromEl) return;
    var a = fromEl.getBoundingClientRect();
    var b = target.getBoundingClientRect();
    var chip = document.createElement('div');
    chip.className = 'm-bag__flychip';
    if (imgUrl) chip.style.backgroundImage = 'url(' + imgUrl + ')';
    chip.style.left = (a.left + a.width / 2 - 24) + 'px';
    chip.style.top = (a.top + a.height / 2 - 24) + 'px';
    document.body.appendChild(chip);
    requestAnimationFrame(function () {
      chip.style.transform = 'translate(' + (b.left + b.width / 2 - (a.left + a.width / 2)) + 'px,' + (b.top + b.height / 2 - (a.top + a.height / 2)) + 'px) scale(.3)';
      chip.style.opacity = '0.2';
    });
    setTimeout(function () {
      chip.remove();
      if (target.animate) target.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.18)' }, { transform: 'scale(1)' }], { duration: 260 });
    }, 1050);
  }

  /* ---------- pre-order ships-together pop-up ---------- */
  /* m-preorder.liquid prints the rust notice inside [data-bag-preorder] only
     while the cart mixes the pre-order with anything else that ships, only in
     retail mode, and only until its cutoff, so the notice IS the rule and this
     code never reads cart lines. Scope it to that block: the net-error and
     gift-over notices wear .m-bag__notice--rust too. Every cart change lands in
     swapFromSections, directly or through refresh(), whichever add path ran.
     The sentence comes from the notice; only the title's date lives here, so
     move it together with the dates in m-preorder.liquid. */
  var PO_KEY = 'srrco_po_together_seen_v1';
  var poMixed = null;     /* the notice at the last look; null until boot */
  var poSeenHere = false; /* storage can throw and it still pops only once */
  var poBox = null;
  var poBack = null;
  function poSeen() {
    if (poSeenHere) return true;
    try { return !!sessionStorage.getItem(PO_KEY); } catch (e) { return false; }
  }
  /* Runs after every swap, and once at boot. The memory of the last look is
     the "before": a bag already mixed at page load never pops. Never throws,
     the bag must not depend on it. */
  function poMixCheck() {
    try {
      var note = document.querySelector('[data-bag-preorder] .m-bag__notice--rust');
      var was = poMixed;
      poMixed = !!note;
      if (was !== false || !note || poSeen()) return;
      var text = (note.textContent || '').trim();
      if (!text) return;
      /* next tick: renderContents opens the drawer right after its swap, and
         openDrawer would pull focus back off the pop-up */
      setTimeout(function () { try { poShow(text); } catch (e) {} }, 0);
    } catch (e) {}
  }
  function poBuild() {
    if (poBox) return poBox;
    var box = document.createElement('div');
    box.className = 'm-bag__po';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-labelledby', 'm-bag-po-title');
    box.setAttribute('aria-describedby', 'm-bag-po-copy');
    box.hidden = true;
    box.innerHTML = '<div class="m-bag__po-panel">'
      + '<div class="m-bag__kicker m-bag__po-kicker">Pre-order</div>'
      + '<h2 class="m-bag__po-title" id="m-bag-po-title">Ships December 4</h2>'
      + '<p class="m-bag__po-copy" id="m-bag-po-copy" data-bag-po-copy></p>'
      + '<button type="button" class="m-bag__po-btn" data-bag-po-ok>Got it</button>'
      + '</div>';
    /* the container IS the dark area, so a click on the black lands here;
       stopped so the document handlers (pickers, chooser, menus) stay asleep */
    box.addEventListener('click', function (e) {
      e.stopPropagation();
      if (e.target === box || e.target.closest('[data-bag-po-ok]')) poHide();
    });
    /* on <body>: a section swap can't wipe it, and it stays out of cart-drawer's
       stacking context and pointer-events:none */
    document.body.appendChild(box);
    poBox = box;
    return box;
  }
  function poShow(text) {
    var box = poBuild();
    if (!box.hidden) return;
    box.querySelector('[data-bag-po-copy]').textContent = text;
    poBack = document.activeElement;
    box.hidden = false;
    document.body.classList.add('m-bag-po-open');
    document.addEventListener('keydown', poKeys, true);
    box.querySelector('[data-bag-po-ok]').focus({ preventScroll: true });
    poSeenHere = true;
    try { sessionStorage.setItem(PO_KEY, '1'); } catch (e) {}
  }
  function poHide() {
    if (!poBox || poBox.hidden) return;
    poBox.hidden = true;
    document.body.classList.remove('m-bag-po-open');
    document.removeEventListener('keydown', poKeys, true);
    /* a swap behind the pop-up replaces the button focus came from: land on
       the fresh drawer instead of dropping focus onto the page */
    var back = poBack;
    poBack = null;
    var usable = back && back !== document.body && back.focus && document.contains(back);
    var spot = usable ? back : (isOpen() ? panel().querySelector('[data-bag-close]') : null);
    if (spot) spot.focus({ preventScroll: true });
  }
  /* capture phase, then stopped: the drawer's Tab trap and Escape sit on
     document and must not hear these while the pop-up is up, or Tab drags
     focus behind it and Escape closes the bag too */
  function poKeys(e) {
    if (e.key !== 'Escape' && e.key !== 'Tab') return;
    e.preventDefault();
    e.stopPropagation();
    if (e.key === 'Escape') poHide();
    else poBox.querySelector('[data-bag-po-ok]').focus({ preventScroll: true });
  }

  /* ---------- Dawn contract: <cart-drawer> ---------- */
  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', class extends HTMLElement {
      getSectionsToRender() {
        return [{ id: DRAWER_SECTION, selector: '[data-bag-drawer-inner]' }];
      }
      renderContents(parsedState) {
        if (parsedState && parsedState.sections) swapFromSections(parsedState.sections);
        var name = '';
        try {
          if (parsedState && parsedState.items && parsedState.items[0]) name = parsedState.items[0].product_title;
          else if (parsedState && parsedState.product_title) name = parsedState.product_title;
        } catch (e) {}
        var img = null;
        try { img = (parsedState.items && parsedState.items[0] && parsedState.items[0].image) || parsedState.image || null; } catch (e) {}
        flyChip(img, lastFocus && lastFocus.getBoundingClientRect ? lastFocus : null);
        openDrawer();
        if (name) toast('Added · ' + name);
      }
      setActiveElement(el) { lastFocus = el; }
      open() { openDrawer(); }
      close() { closeDrawer(); }
    });
  }

  /* ---------- gift card chip (GIFTBRIDGE balance) ---------- */
  var gcState = { gan: null, balance: null, missing: false };
  try { gcState.gan = sessionStorage.getItem(GC_KEY) || null; } catch (e) {}
  function paintGiftCardChip() {
    document.querySelectorAll('[data-bag-gcchip-slot]').forEach(function (slot) {
      if (!gcState.gan) { slot.innerHTML = ''; return; }
      var last4 = gcState.gan.slice(-4);
      var total = currentTotal();
      var line = gcState.balance == null
        ? 'Have the number handy — it goes in the gift card box at checkout.'
        : gcState.balance >= total && total > 0
          ? 'Covers this whole order once you enter it at checkout.'
          : 'Covers ' + money(Math.min(gcState.balance, total)) + ' once you enter it at checkout; the rest goes on a card.';
      var bal = gcState.balance == null ? '' : ' · ' + money(gcState.balance);
      slot.innerHTML =
        '<div class="m-bag__chip" data-bag-gcchip>' +
          '<div class="m-bag__chip-t"><strong>Gift card ···· ' + esc(last4) + bal + '</strong><br><span class="m-bag__chip-sub">' + line + ' <button type="button" class="m-bag__textlink" data-bag-gc-copy>Copy the number</button></span></div>' +
          '<button type="button" class="m-bag__chip-x" data-bag-gc-remove aria-label="Remove the gift card">×</button>' +
        '</div>';
    });
  }
  function currentTotal() {
    var el = document.querySelector('.m-bag__grandnum');
    if (!el) return 0;
    return Math.round(parseFloat(el.textContent.replace(/[^0-9.]/g, '')) * 100) || 0;
  }
  function checkGan(gan) {
    return fetch(giftbridgeBalanceUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ gan: gan })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); });
  }
  var GAN_RE = /^[A-Za-z0-9]{8,20}$/;
  (function bootGan() {
    try {
      var params = new URLSearchParams(location.search);
      var fromUrl = (params.get('gc') || '').replace(/[\s-]/g, '');
      if (GAN_RE.test(fromUrl)) {
        gcState.gan = fromUrl;
        sessionStorage.setItem(GC_KEY, fromUrl);
        params.delete('gc');
        var q = params.toString();
        history.replaceState({}, '', location.pathname + (q ? '?' + q : '') + location.hash);
      }
    } catch (e) {}
    if (gcState.gan) {
      var cached = null;
      try { cached = JSON.parse(sessionStorage.getItem(GC_KEY + '_bal') || 'null'); } catch (e) {}
      if (cached && cached.gan === gcState.gan && Date.now() - cached.at < 10 * 60000) {
        gcState.balance = cached.balanceCents;
        paintGiftCardChip();
      } else {
        checkGan(gcState.gan).then(function (res) {
          if (res.ok && res.d && typeof res.d.balanceCents === 'number' && res.d.active !== false) {
            gcState.balance = res.d.balanceCents;
            try { sessionStorage.setItem(GC_KEY + '_bal', JSON.stringify({ gan: gcState.gan, balanceCents: gcState.balance, at: Date.now() })); } catch (e) {}
          } else if (res.d && (res.d.error === 'not_found' || res.d.active === false || res.d.error === 'gift_card_unusable')) {
            gcState.gan = null;
            try { sessionStorage.removeItem(GC_KEY); sessionStorage.removeItem(GC_KEY + '_bal'); } catch (e) {}
          }
          paintGiftCardChip();
        }).catch(function () {});
      }
    }
  })();

  /* ---------- codes ---------- */
  function appliedCodes() {
    var codes = [];
    document.querySelectorAll('[data-bag-chip]').forEach(function (c) {
      var code = c.getAttribute('data-bag-chip');
      if (code && codes.indexOf(code) === -1) codes.push(code);
    });
    return codes;
  }
  var codeState = { text: '', hit: false };
  function paintCodeMsg() {
    document.querySelectorAll('[data-bag-code-msg]').forEach(function (b) {
      b.textContent = codeState.text || '';
      b.classList.toggle('is-hit', !!codeState.hit);
      b.classList.toggle('is-miss', !codeState.hit && !!codeState.text);
    });
  }
  function codeMsg(scope, text, hit) {
    /* held in state so a later section swap re-paints it instead of wiping it */
    codeState = { text: text || '', hit: !!hit };
    paintCodeMsg();
  }
  function applyCode(code, btn) {
    if (busy) return;
    busy = true;
    if (btn) btn.disabled = true;
    var codes = appliedCodes();
    if (codes.indexOf(code) === -1) codes.push(code);
    mutate('/cart/update.js', { discount: codes.join(',') }).then(function (res) {
      busy = false; if (btn) btn.disabled = false;
      if (!res.ok) { codeMsg('all', 'Could not check that code just now. Try again.', false); return; }
      swapFromSections(res.d.sections);
      var norm = code.toUpperCase();
      var applied = appliedCodes().some(function (cc) { return cc.toUpperCase() === norm; });
      if (applied) {
        codeMsg('all', norm + ' applied. ', true);
        document.querySelectorAll('[data-bag-code]').forEach(function (i) { i.value = ''; });
        return;
      }
      /* Shopify stores unmatched codes too — scrub this one so it never rides to checkout */
      var keep = appliedCodes();
      mutate('/cart/update.js', { discount: keep.join(',') })
        .then(function (r3) { if (r3.ok) swapFromSections(r3.d.sections); })
        .catch(function () {});
      /* a real code that touches nothing in this bag? */
      var stored = (res.d && res.d.discount_codes) || [];
      var known = stored.some(function (dc) { return dc && dc.code && dc.code.toUpperCase() === norm && dc.applicable; });
      if (known) {
        codeMsg('all', norm + ' is a real code, but it doesn\u2019t apply to anything in your bag.', false);
        return;
      }
      /* not a discount — a gift card number? */
      var gan = code.replace(/[\s-]/g, '');
      if (GAN_RE.test(gan)) {
        checkGan(gan).then(function (r2) {
          if (r2.ok && r2.d && typeof r2.d.balanceCents === 'number' && r2.d.active !== false) {
            gcState.gan = gan;
            gcState.balance = r2.d.balanceCents;
            try {
              sessionStorage.setItem(GC_KEY, gan);
              sessionStorage.setItem(GC_KEY + '_bal', JSON.stringify({ gan: gan, balanceCents: r2.d.balanceCents, at: Date.now() }));
            } catch (e) {}
            paintGiftCardChip();
            codeMsg('all', 'Gift card ···· ' + gan.slice(-4) + ' · ' + money(r2.d.balanceCents) + ' · have it ready to enter at checkout.', true);
            document.querySelectorAll('[data-bag-code]').forEach(function (i) { i.value = ''; });
          } else {
            codeMsg('all', 'That code did not match a discount or a gift card. Check the spelling?', false);
          }
        }).catch(function () { codeMsg('all', 'That code did not match a discount or a gift card. Check the spelling?', false); });
      } else {
        codeMsg('all', 'That code did not match a discount or a gift card. Check the spelling?', false);
      }
    }).catch(function () { busy = false; if (btn) btn.disabled = false; codeMsg('all', 'Could not check that code just now. Try again.', false); });
  }
  function removeCode(code) {
    if (busy) return;
    busy = true;
    var codes = appliedCodes().filter(function (c) { return c !== code; });
    mutate('/cart/update.js', { discount: codes.join(',') }).then(function (res) {
      busy = false;
      if (res.ok) { swapFromSections(res.d.sections); codeMsg('all', '', false); }
    }).catch(function () { busy = false; netFail(function () { removeCode(code); }); });
  }

  /* ---------- gift block ---------- */
  var giftTimer = null;
  /* Owner 2026-08-24: the packing slip fits SIX printed lines — that is
     the real limit, characters are whatever fits. Estimate printed lines
     from hard breaks plus soft wrap. WRAP must match the slip's line
     width (GIFTBRIDGE pipeline) — tune the two together. */
  var GIFT_WRAP = 44;
  var GIFT_MAX_LINES = 6;
  function giftLines(text) {
    return String(text || '').split('\n').reduce(function (n, ln) {
      return n + Math.max(1, Math.ceil(ln.length / GIFT_WRAP));
    }, 0);
  }
  function giftFieldsOf(scope) {
    return {
      to: scope.querySelector('[data-bag-gift-to]'),
      from: scope.querySelector('[data-bag-gift-from]'),
      msg: scope.querySelector('[data-bag-gift-msg]'),
      count: scope.querySelector('[data-bag-gift-count]'),
      over: scope.querySelector('[data-bag-gift-over]')
    };
  }
  function giftSave(scope, collapse) {
    if (!document.documentElement.contains(scope)) {
      /* the section re-rendered under us — save from the live DOM instead */
      scope = document.querySelector('[data-bag-drawer-inner] [data-bag-gift], [data-bag-page-inner] [data-bag-gift]') || scope;
    }
    var tgl = scope.querySelector('[data-bag-gift-toggle]');
    if (tgl && tgl.getAttribute('aria-checked') !== 'true') return;
    var f = giftFieldsOf(scope);
    if (!f.msg) return;
    var msg = f.msg.value || '';
    if (msg && giftLines(msg) > GIFT_MAX_LINES) {
      f.over.hidden = false;
      f.over.textContent = 'That\u2019s past ' + GIFT_MAX_LINES + ' printed lines — trim a little and it saves.';
      f.msg.classList.add('is-over');
      return;
    }
    f.over.hidden = true;
    f.msg.classList.remove('is-over');
    var attrs = {
      'Gift order': 'yes',
      'Gift to': (f.to && f.to.value || '').slice(0, 60),
      'Gift from': (f.from && f.from.value || '').slice(0, 60)
    };
    mutate('/cart/update.js', { attributes: attrs, note: msg }).then(function (res) {
      if (!res.ok) return;
      if (collapse) swapFromSections(res.d.sections);
      else {
        /* quiet save: keep focus, just sync the other surface's summary */
        document.querySelectorAll('[data-bag-gift-summary]').forEach(function (s) {
          var to = attrs['Gift to'];
          s.textContent = 'Gift' + (to ? ' for ' + to : '') + (msg ? ' · message added' : '');
        });
      }
    }).catch(function () {});
  }
  function giftOff(scope) {
    mutate('/cart/update.js', { attributes: { 'Gift order': '', 'Gift to': '', 'Gift from': '' }, note: '' })
      .then(function (res) { if (res.ok) swapFromSections(res.d.sections); })
      .catch(function () { netFail(function () { giftOff(scope); }); });
  }

  /* ---------- cadence picker ---------- */
  function closePickers() {
    document.querySelectorAll('.m-bag__picker').forEach(function (p) { p.remove(); });
    document.querySelectorAll('[data-bag-cadence]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  function openPicker(btn, lineEl) {
    closePickers();
    var plans = (lineEl.getAttribute('data-bag-plans') || '').split(',').filter(Boolean);
    var current = lineEl.getAttribute('data-bag-plan-current');
    if (!plans.length) return;
    var pick = document.createElement('div');
    pick.className = 'm-bag__picker';
    pick.setAttribute('role', 'group');
    pick.setAttribute('aria-label', 'Delivery cadence');
    plans.forEach(function (p) {
      var id = p.split(':')[0];
      var label = p.split(':').slice(1).join(':');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'm-bag__pickchip' + (id === current ? ' is-on' : '');
      b.textContent = label;
      b.setAttribute('data-bag-plan-pick', id);
      b.setAttribute('aria-pressed', id === current ? 'true' : 'false');
      pick.appendChild(b);
    });
    btn.setAttribute('aria-expanded', 'true');
    btn.parentElement.appendChild(pick);
    var cur = pick.querySelector('.is-on');
    if (cur) cur.focus({ preventScroll: true });
  }
  function changeCadence(lineEl, planId) {
    var key = lineEl.getAttribute('data-bag-key');
    var qty = parseInt(lineEl.querySelector('[data-bag-qty-n]').textContent, 10) || 1;
    lineVeil(lineEl, true);
    closePickers();
    var body = { id: key, quantity: qty, selling_plan: parseInt(planId, 10) };
    var send = function () {
      mutate('/cart/change.js', body).then(function (res) {
        if (res.ok) { swapFromSections(res.d.sections); netClear(); }
        else { lineVeil(lineEl, false); netFail(function () { changeCadence(lineEl, planId); }); }
      }).catch(function () { lineVeil(lineEl, false); netFail(function () { changeCadence(lineEl, planId); }); });
    };
    /* a hand-picked week plan retires the exact-day rhythm: rebuild the
       line's properties from the live cart minus _srrco_cadence_days
       (change.js `properties` replaces the whole set). Left in place the
       stale property would keep the drawer saying "Every N days" and the
       engine would rewrite the fresh contract back to the old days. */
    if (lineEl.hasAttribute('data-bag-cadence-days')) {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          var it = cart && (cart.items || []).filter(function (i) { return i.key === key; })[0];
          if (it && it.properties) {
            var props = {};
            Object.keys(it.properties).forEach(function (k) { if (k !== '_srrco_cadence_days') props[k] = it.properties[k]; });
            body.properties = props;
          }
          send();
        })
        .catch(send);
    } else send();
  }

  /* ---------- subscribe / one-time swaps ---------- */
  function defaultPlan(plansAttr) {
    var plans = (plansAttr || '').split(',').filter(Boolean);
    var two = plans.find(function (p) { return /2 weeks/i.test(p); });
    var pick = two || plans[0];
    return pick ? parseInt(pick.split(':')[0], 10) : null;
  }
  function convertRemove(lineEl, key) {
    mutate('/cart/change.js', { id: key, quantity: 0 }).then(function (res) {
      if (res.ok) { swapFromSections(res.d.sections); netClear(); }
      else if (res.status === 404) { refresh().then(netClear); }
      else { lineVeil(lineEl, false); netFail(function () { convertRemove(lineEl, key); }); }
    }).catch(function () { lineVeil(lineEl, false); netFail(function () { convertRemove(lineEl, key); }); });
  }
  function convertLine(lineEl, variantId, planId) {
    var key = lineEl.getAttribute('data-bag-key');
    var qtyEl = lineEl.querySelector('[data-bag-qty-n]');
    var qty = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;
    lineVeil(lineEl, true);
    var addBody = { items: [{ id: parseInt(variantId, 10), quantity: qty }] };
    if (planId) addBody.items[0].selling_plan = planId;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(addBody) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { lineVeil(lineEl, false); netFail(function () { convertLine(lineEl, variantId, planId); }); return; }
        /* the add landed — from here only the remove ever retries */
        convertRemove(lineEl, key);
      })
      .catch(function () { lineVeil(lineEl, false); netFail(function () { convertLine(lineEl, variantId, planId); }); });
  }

  /* ---------- ship date (cart attribute srrco_ship_on) ---------- */
  /* "YYYY-MM-DD" on the roastery's calendar (America/Denver, the same
     day the backend judges by); empty string clears back to the
     DEFAULT — the next business day (never "today": that's the order
     date). Selectable = business days only, from the first business
     day after today through today+60; weekends, the six roastery
     holidays and the closed days in m-ship-rules.liquid are muted, and
     while that file's sale cap runs the calendar stops at its `latest`.
     All day stepping rides noon-UTC anchors — raw local ms day math can
     skip a calendar date across a DST edge (the m-order bug, fixed
     2026-08-24). */
  function shipTodayStr() {
    var d = new Date();
    try {
      var p = {};
      new Intl.DateTimeFormat('en-US', { timeZone: 'America/Denver', year: 'numeric', month: '2-digit', day: '2-digit' })
        .formatToParts(d).forEach(function (x) { p[x.type] = x.value; });
      if (/^\d{4}$/.test(p.year) && /^\d{2}$/.test(p.month) && /^\d{2}$/.test(p.day)) return p.year + '-' + p.month + '-' + p.day;
    } catch (e) {}
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }
  /* holiday rules = DATA (snippets/m-ship-rules.liquid, a JSON script
     inside the ship box): { saleCap: {from, to, latest, note},
     closed: ["YYYY-MM-DD" | "YYYY-MM-DD..YYYY-MM-DD"] }. Re-parsed only
     when the text changes (section swaps re-render it); bad JSON or a
     missing block = no extra rules, the calendar works as before. */
  var shipRulesSrc = null, shipRulesObj = { cap: null, closed: [] };
  function shipRules() {
    var el = document.querySelector('script[data-ship-rules]');
    var src = el ? el.textContent : '';
    if (src === shipRulesSrc) return shipRulesObj;
    shipRulesSrc = src;
    var out = { cap: null, closed: [] };
    var iso = /^\d{4}-\d{2}-\d{2}$/;
    try {
      var j = src ? JSON.parse(src) : {};
      var c = j && j.saleCap;
      if (c && iso.test(c.from) && iso.test(c.to) && iso.test(c.latest)) {
        out.cap = { from: c.from, to: c.to, latest: c.latest, note: typeof c.note === 'string' ? c.note : '' };
      }
      ((j && j.closed) || []).forEach(function (entry) {
        var m = /^(\d{4}-\d{2}-\d{2})(?:\.\.(\d{4}-\d{2}-\d{2}))?$/.exec(String(entry).trim());
        if (m && (m[2] || m[1]) >= m[1]) out.closed.push([m[1], m[2] || m[1]]);
      });
    } catch (e) {}
    shipRulesObj = out;
    return out;
  }
  function shipClosed(ds) {
    var c = shipRules().closed;
    for (var i = 0; i < c.length; i++) if (ds >= c[i][0] && ds <= c[i][1]) return true;
    return false;
  }
  /* the sale cap's last pickable day while today sits inside the sale */
  function shipCapLatest() {
    var cap = shipRules().cap;
    var t = shipTodayStr();
    return cap && t >= cap.from && t <= cap.to ? cap.latest : '';
  }
  function shipLast() {
    var last = shipAddDays(shipTodayStr(), 60);
    var cap = shipCapLatest();
    return cap && cap < last ? cap : last;
  }
  function shipAnchor(ds) { return new Date(ds + 'T12:00:00Z'); }
  function shipAddDays(ds, n) {
    var t = new Date(shipAnchor(ds).getTime() + n * 86400000);
    return t.getUTCFullYear() + '-' + String(t.getUTCMonth() + 1).padStart(2, '0') + '-' + String(t.getUTCDate()).padStart(2, '0');
  }
  /* US holidays the roastery won't ship (owner 2026-08-30): New Year's,
     Memorial Day, July 4, Labor Day, Thanksgiving, Christmas */
  var shipHolidayCache = {};
  function shipHolidays(year) {
    if (shipHolidayCache[year]) return shipHolidayCache[year];
    var y = String(year);
    function nthDow(month, dow, n) { /* month 1-based; n = 1st.. or -1 = last */
      if (n === -1) {
        var lastD = new Date(Date.UTC(year, month, 0, 12)); /* day 0 of next month */
        var back = (lastD.getUTCDay() - dow + 7) % 7;
        return y + '-' + String(month).padStart(2, '0') + '-' + String(lastD.getUTCDate() - back).padStart(2, '0');
      }
      var firstD = new Date(Date.UTC(year, month - 1, 1, 12));
      var fwd = (dow - firstD.getUTCDay() + 7) % 7;
      return y + '-' + String(month).padStart(2, '0') + '-' + String(1 + fwd + (n - 1) * 7).padStart(2, '0');
    }
    var set = {};
    set[y + '-01-01'] = 1;     /* New Year's Day */
    set[nthDow(5, 1, -1)] = 1; /* Memorial Day — last Monday in May */
    set[y + '-07-04'] = 1;     /* Independence Day */
    set[nthDow(9, 1, 1)] = 1;  /* Labor Day — first Monday in September */
    set[nthDow(11, 4, 4)] = 1; /* Thanksgiving — fourth Thursday in November */
    set[y + '-12-25'] = 1;     /* Christmas Day */
    shipHolidayCache[year] = set;
    return set;
  }
  function shipIsBiz(ds) {
    var dw = shipAnchor(ds).getUTCDay();
    if (dw === 0 || dw === 6) return false;
    if (shipClosed(ds)) return false;
    return !shipHolidays(parseInt(ds.slice(0, 4), 10))[ds];
  }
  /* first business day strictly after today — a Friday order ships
     Monday; the day before Thanksgiving ships Friday */
  function shipNextBiz() {
    var d = shipAddDays(shipTodayStr(), 1);
    var guard = 0;
    while (!shipIsBiz(d) && guard++ < 60) d = shipAddDays(d, 1);
    return d;
  }
  function shipInWindow(v) {
    return /^\d{4}-\d{2}-\d{2}$/.test(v) && v > shipTodayStr() && v <= shipLast();
  }
  /* a date the calendar would offer right now */
  function shipAllowed(v) { return shipInWindow(v) && shipIsBiz(v); }
  function shipDayLabel(ds) {
    return new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric' }).format(shipAnchor(ds));
  }
  /* server-rendered Liquid prints "Next business day"; the client owns
     the concrete date ("Mon, Sep 1 · next business day") — repainted at
     boot and after every section swap so the row never goes stale */
  function paintShipRows() {
    document.querySelectorAll('[data-bag-shipon]').forEach(function (box) {
      var lab = box.querySelector('[data-bag-shipon-label]');
      if (!lab) return;
      var v = box.getAttribute('data-bag-shipon-value') || '';
      /* generated strings only (Intl day labels) — safe as markup; the
         date leads, the explainer tags along quieter */
      if (v !== '' && shipAllowed(v)) lab.innerHTML = 'Ships ' + shipDayLabel(v);
      else lab.innerHTML = shipDayLabel(shipNextBiz()) + '<span class="m-bag__shipon-tag">next business day</span>';
      /* one line after a saved date was cleared by the rules */
      var note = box.querySelector('[data-bag-shipon-note]');
      if (shipNote) {
        if (!note) {
          note = document.createElement('div');
          note.className = 'm-bag__shipon-note';
          note.setAttribute('data-bag-shipon-note', '');
          note.setAttribute('role', 'status');
          var row = box.querySelector('.m-bag__ship-row');
          if (row && row.nextSibling) box.insertBefore(note, row.nextSibling); else box.appendChild(note);
        }
        note.textContent = shipNote;
      } else if (note) {
        note.parentNode.removeChild(note);
      }
    });
  }
  /* the house month calendar (m-order's .m-ord__cal pattern, bag-scoped):
     bounded ‹ › arrows, S M T W T F S, real grid; only business days in
     the window render as buttons — everything else is a muted span */
  var shipCalMonth = null; /* displayed 'YYYY-MM'; null = follow the pick */
  function shipCalRender(box) {
    var mount = box.querySelector('[data-bag-shipon-cal]');
    if (!mount) return;
    var today = shipTodayStr();
    var first = shipNextBiz();
    var last = shipLast();
    var chosen = box.getAttribute('data-bag-shipon-value') || '';
    if (!shipAllowed(chosen)) chosen = '';
    /* no attribute = the default day reads as picked; tapping it clears */
    var selected = chosen || first;
    var firstMonth = first.slice(0, 7), lastMonth = last.slice(0, 7);
    if (!shipCalMonth || shipCalMonth < firstMonth || shipCalMonth > lastMonth) shipCalMonth = selected.slice(0, 7);
    mount.innerHTML = '';
    var head = document.createElement('div');
    head.className = 'm-bag__cal-head';
    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'm-bag__cal-nav';
    prev.setAttribute('data-bag-shipon-nav', '-1');
    prev.setAttribute('aria-label', 'Previous month');
    prev.textContent = '‹';
    prev.disabled = shipCalMonth <= firstMonth;
    var monthEl = document.createElement('span');
    monthEl.className = 'm-bag__cal-month';
    monthEl.textContent = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'long', year: 'numeric' }).format(shipAnchor(shipCalMonth + '-01'));
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'm-bag__cal-nav';
    next.setAttribute('data-bag-shipon-nav', '1');
    next.setAttribute('aria-label', 'Next month');
    next.textContent = '›';
    next.disabled = shipCalMonth >= lastMonth;
    head.appendChild(prev);
    head.appendChild(monthEl);
    head.appendChild(next);
    mount.appendChild(head);
    var grid = document.createElement('div');
    grid.className = 'm-bag__cal-grid';
    ['S', 'M', 'T', 'W', 'T', 'F', 'S'].forEach(function (ch) {
      var dw = document.createElement('span');
      dw.className = 'm-bag__cal-dow';
      dw.textContent = ch;
      grid.appendChild(dw);
    });
    var lead = shipAnchor(shipCalMonth + '-01').getUTCDay();
    var yy = parseInt(shipCalMonth.slice(0, 4), 10);
    var mm = parseInt(shipCalMonth.slice(5, 7), 10);
    var days = new Date(Date.UTC(yy, mm, 0, 12)).getUTCDate();
    var total = Math.ceil((lead + days) / 7) * 7;
    for (var ci = 0; ci < total; ci++) {
      var dd = ci - lead + 1;
      if (dd < 1 || dd > days) {
        var blank = document.createElement('span');
        blank.className = 'm-bag__cal-cell m-bag__cal-cell--blank';
        grid.appendChild(blank);
        continue;
      }
      var ds = shipCalMonth + '-' + String(dd).padStart(2, '0');
      if (ds > today && ds <= last && shipIsBiz(ds)) {
        var cb = document.createElement('button');
        cb.type = 'button';
        cb.className = 'm-bag__cal-cell' + (ds === selected ? ' is-selected' : '');
        cb.setAttribute('data-bag-shipon-day', ds);
        cb.setAttribute('aria-label', shipDayLabel(ds) + (ds === first ? ' (next business day)' : ''));
        cb.textContent = String(dd);
        grid.appendChild(cb);
      } else {
        /* today, weekends, holidays, closed days, past days, beyond
           +60 or the sale cap */
        var offc = document.createElement('span');
        offc.className = 'm-bag__cal-cell m-bag__cal-cell--off' + (ds === today ? ' is-today' : '');
        offc.textContent = String(dd);
        grid.appendChild(offc);
      }
    }
    mount.appendChild(grid);
    /* while the sale cap runs, one quiet line says why later days are off */
    var capDay = shipCapLatest();
    var capNote = capDay ? shipRules().cap.note : '';
    if (capNote) {
      var cn = document.createElement('p');
      cn.className = 'm-bag__cal-note';
      cn.textContent = capNote.replace('{latest}', shipDayLabel(capDay));
      mount.appendChild(cn);
    }
  }
  function setShipDate(value) {
    if (busy) return;
    busy = true;
    shipNote = '';
    mutate('/cart/update.js', { attributes: { srrco_ship_on: value } }).then(function (res) {
      busy = false;
      if (res.ok) { swapFromSections(res.d.sections); netClear(); }
      else netFail(function () { setShipDate(value); });
    }).catch(function () { busy = false; netFail(function () { setShipDate(value); }); });
  }
  function closeShipPickers() {
    var any = false;
    document.querySelectorAll('[data-bag-shipon-picker]:not([hidden])').forEach(function (p) { p.hidden = true; any = true; });
    document.querySelectorAll('[data-bag-shipon-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    return any;
  }
  /* Liquid renders a past srrco_ship_on as unset and flags it stale —
     drop the attribute quietly so checkout never carries yesterday's
     date (at most one post per page life; no section swap needed). */
  var shipScrubbed = false;
  function scrubStaleShip() {
    if (shipScrubbed) return;
    if (!document.querySelector('[data-bag-shipon][data-bag-shipon-stale="1"]')) return;
    shipScrubbed = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { srrco_ship_on: '' } })
    }).catch(function () {});
  }
  /* A saved date still ahead that the rules no longer allow (a closed
     day, past the sale cap, a weekend): Liquid can't read the rules, so
     it renders the date as set. Clear it here, show the default day,
     and say so in one line. The attribute post is fire-and-forget like
     the stale scrub; a failed post retries on the next paint. */
  var shipNote = '';
  var shipRuleScrubbing = '';
  function scrubRuleShip() {
    var bad = '';
    document.querySelectorAll('[data-bag-shipon]').forEach(function (box) {
      var v = box.getAttribute('data-bag-shipon-value') || '';
      if (v === '' || shipAllowed(v)) return;
      bad = v;
      box.setAttribute('data-bag-shipon-value', '');
      var rs = box.querySelector('[data-bag-shipon-reset]');
      if (rs) rs.parentNode.removeChild(rs);
    });
    if (!bad) return;
    if (/^\d{4}-\d{2}-\d{2}$/.test(bad) && bad > shipTodayStr()) {
      shipNote = shipDayLabel(bad) + ' is no longer available. Pick another date.';
    }
    if (shipRuleScrubbing === bad) return;
    shipRuleScrubbing = bad;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { srrco_ship_on: '' } })
    }).then(function (r) { if (!r.ok) shipRuleScrubbing = ''; })
      .catch(function () { shipRuleScrubbing = ''; });
  }

  /* ---------- delegated events ---------- */
  document.addEventListener('change', function (e) {
    var cr = e.target && e.target.closest ? e.target.closest('[data-bag-credit]') : null;
    if (cr) creditToggle(cr);
  });
  /* the page-load Shopify→account bridge (m-theme-session) just signed us in:
     drop the cached 401 and repaint credit + rewards from the real session */
  document.addEventListener('srrco:session', function () {
    creditAuth = 0; creditCards = null; creditPrefLoaded = false; rwMeCache = null;
    try { paintDrawerRewards(); } catch (e) {}
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && rwPopOpen) {
      var popE = document.querySelector('[data-bag-rwpop]');
      if (popE) popE.hidden = true;
      rwPopOpen = false;
    }
  });
  document.addEventListener('click', function (e) {
    var t0 = e.target;
    if (t0 && t0.closest) {
      /* the credit switch drives the hidden checkbox the rest of the code listens to */
      var csw = t0.closest('[data-bag-credit-toggle]');
      if (csw && !csw.disabled) {
        var crow = csw.closest('[data-bag-credit-row]');
        var ccb = crow && crow.querySelector('[data-bag-credit]');
        if (ccb) { ccb.checked = !ccb.checked; creditToggle(ccb); }
        return;
      }
      /* the rewards chooser collapses on any click outside it (owner 2026-09-14) */
      if (rwPopOpen && !t0.closest('[data-bag-rwpop]') && !t0.closest('[data-bag-rw-open]')) {
        var popX = document.querySelector('[data-bag-rwpop]');
        if (popX) popX.hidden = true;
        rwPopOpen = false;
      }
      if (t0.closest('[data-bag-rw-open]')) { if (rwPopOpen) { rwPopOpen = false; var popT = document.querySelector('[data-bag-rwpop]'); if (popT) popT.hidden = true; return; } rwPopOpen = true; var pop = document.querySelector('[data-bag-rwpop]'); if (pop) pop.hidden = false; loadRwCoffees('sample'); loadRwCoffees('bag'); return; }
      if (t0.closest('[data-bag-rw-close]')) { rwPopOpen = false; var pop2 = document.querySelector('[data-bag-rwpop]'); if (pop2) pop2.hidden = true; return; }
      var grindOf = t0.closest('[data-bag-rw-grind-of]');
      if (grindOf) {
        /* both grinds on offer: the grind row commits, nothing is reserved yet */
        var ofId = parseInt(grindOf.getAttribute('data-bag-rw-grind-of'), 10);
        rwPickCoffee = (rwCoffees.bag || []).filter(function (co) { return co.id === ofId; })[0] || null;
        paintRwCoffees();
        return;
      }
      if (t0.closest('[data-bag-rw-grind-back]')) { rwPickCoffee = null; paintRwCoffees(); return; }
      var coffeePick = t0.closest('[data-bag-rw-coffee]');
      if (coffeePick) {
        var vid = parseInt(coffeePick.getAttribute('data-bag-rw-coffee'), 10);
        var rkey = rwPendingKey;
        coffeePick.disabled = true;
        rwPickKind = null;
        rwPickCoffee = null;
        rwPendingKey = null;
        rwPopOpen = false;
        var rbox2 = document.querySelector('[data-bag-rewards]');
        if (!rkey || !rbox2) return;
        toast('In the bag \u2014 pricing it\u2026');
        /* the reserve and the product-add fly together; the code lands on
           whichever finishes last, then ONE refresh paints the $0 line */
        var reserveP = fetch(rbox2.getAttribute('data-api') + '/shop/rewards/redeem', {
          method: 'POST', credentials: 'include',
          headers: Object.assign({ 'Content-Type': 'application/json' }, rwHeaders(rbox2)),
          body: JSON.stringify({ key: rkey, defer: true })
        }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); });
        var addP = fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }) });
        /* the line shows the moment the add lands — it flips to $0 when
           the code catches up */
        addP.then(function () { return refresh(); }).catch(function () {});
        Promise.all([reserveP, addP])
          .then(function (both) {
            var res = both[0];
            if (!res.ok || !res.d || !res.d.redemption || !res.d.redemption.code) throw new Error('reserve failed');
            try {
              var map2 = JSON.parse(sessionStorage.getItem('srrco_rw_reserved') || '{}');
              map2[res.d.redemption.code.toUpperCase()] = { id: res.d.redemption.id, v: vid };
              sessionStorage.setItem('srrco_rw_reserved', JSON.stringify(map2));
            } catch (err) {}
            rwMeCache = null;
            var all2 = appliedCodes();
            if (all2.indexOf(res.d.redemption.code) === -1) all2.push(res.d.redemption.code);
            return mutate('/cart/update.js', { discount: all2.join(',') }).catch(function () { return null; });
          })
          .then(function () { toast('It rides free'); return refresh(); })
          .catch(function () {
            /* the product may have landed without its reward — take it back out */
            releaseRewardForLine(String(vid));
            toast('That one did not go through — try again');
            refresh();
          });
        return;
      }
      var choice = t0.closest('[data-bag-rw-key]');
      if (choice) {
        var ck = choice.getAttribute('data-bag-rw-key');
        if (ck === 'sample_4oz' || ck === 'bag_12oz') {
          /* the coffee comes first — nothing is reserved until they pick
             one, and the product line is then the thing they can X */
          rwPendingKey = ck;
          rwPickKind = ck === 'sample_4oz' ? 'sample' : 'bag';
          rwPopOpen = true;
          loadRwCoffees(rwPickKind).then(function () { paintRwCoffees(); });
          paintRwCoffees();
          return;
        }
        redeemDrawerReward(choice);
        return;
      }
      if (t0.closest('[data-bag-est-why]')) { var ep = document.querySelector('[data-bag-est-pop]'); if (ep) { ep.hidden = !ep.hidden; var zi = ep.querySelector('[data-bag-est-zip-in]'); if (zi && !ep.hidden) { var s = estZip(); zi.value = (s && s.zip) || (document.querySelector('[data-bag-est]') || { getAttribute: function () { return ''; } }).getAttribute('data-bag-est-zip') || ''; zi.focus(); } } return; }
      if (t0.closest('[data-bag-est-go]')) {
        var ep2 = document.querySelector('[data-bag-est-pop]');
        var zin = ep2 ? ep2.querySelector('[data-bag-est-zip-in]') : null;
        var z = zin ? zin.value.trim() : '';
        if (/^\d{5}(-\d{4})?$/.test(z)) {
          try { localStorage.setItem('srrco_est_zip', JSON.stringify({ zip: z, country: 'US', province: '' })); } catch (err) {}
          estCache = {};
          ep2.hidden = true;
          paintEstimate();
        } else if (zin) { zin.focus(); }
        return;
      }
      var undo = t0.closest('[data-bag-credit-undo]');
      if (undo) {
        var rid = undo.getAttribute('data-bag-credit-undo');
        if (rid.indexOf('pending-') === 0) { toast('One sec — still landing'); return; }
        var chipN = undo.closest('[data-bag-credit-chip]');
        if (chipN) chipN.remove();
        var ubox = document.querySelector('[data-bag-rewards]');
        fetch(ubox.getAttribute('data-api') + '/shop/rewards/redemption/unconvert', {
          method: 'POST', credentials: 'include',
          headers: Object.assign({ 'Content-Type': 'application/json' }, rwHeaders(ubox)),
          body: JSON.stringify({ id: rid })
        }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            try {
              var cm = JSON.parse(sessionStorage.getItem('srrco_rw_credit') || '{}');
              delete cm[rid];
              sessionStorage.setItem('srrco_rw_credit', JSON.stringify(cm));
            } catch (err) {}
            if (res.ok) {
              toast('Un-converted — points returned');
              rwMeCache = null; creditCards = null;
              paintDrawerRewards(); paintCreditChips();
            } else {
              toast(res.d && res.d.error === 'credit_spent' ? 'That credit was already spent' : 'Could not un-convert — write shop@');
              paintCreditChips();
            }
          })
          .catch(function () { toast('Could not un-convert — try again'); paintCreditChips(); });
        return;
      }
      if (t0.closest('[data-bag-credit-copy]') && creditGan) {
        try { navigator.clipboard.writeText(creditGan); t0.closest('[data-bag-credit-copy]').textContent = 'Copied'; } catch (err) {}
        return;
      }
    }
    var t = e.target;

    /* header glyph opens the drawer */
    var headCart = t.closest('.mtop__cart, .mhead__cart');
    if (headCart && root() && window.location.pathname.indexOf('/cart') !== 0 && !document.querySelector('[data-mord]')) {
      e.preventDefault();
      openDrawer();
      return;
    }

    if (t.closest('[data-bag-close]')) { closeDrawer(); return; }
    var veilTap = t.closest('[data-bag-root]');
    if (veilTap && (t.hasAttribute('data-bag-veil') || t === veilTap)) { closeDrawer(); return; }

    var retry = t.closest('[data-bag-retry]');
    if (retry) { netClear(); if (lastAction) { var fn = lastAction; lastAction = null; fn(); } else refresh(); return; }

    /* clear cart — one click, no confirm (owner 2026-08-30) */
    var clr = t.closest('[data-bag-clear]');
    if (clr) {
      if (busy) return;
      busy = true;
      clr.disabled = true;
      /* clear.js empties line items only — attributes survive it, so a
         chosen ship date is dropped too: a fresh order never inherits a
         stale srrco_ship_on */
      document.querySelectorAll('[data-bag-line]').forEach(function (el) { lineVeil(el, true); });
      mutate('/cart/clear.js', {}).then(function (res) {
        busy = false;
        clr.disabled = false;
        if (!res.ok) { netFail(function () { refresh(); }); return; }
        swapFromSections(res.d.sections);
        netClear();
        /* the ship date rides cart attributes, which clear.js leaves
           behind — wiped in the background, nothing visual depends on it */
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { srrco_ship_on: '' } })
        }).catch(function () {});
      }).catch(function () { busy = false; clr.disabled = false; netFail(function () { refresh(); }); });
      return;
    }

    var step = t.closest('[data-bag-qty]');
    if (step && !step.disabled) {
      var lineEl = step.closest('[data-bag-line]');
      var key = lineEl.getAttribute('data-bag-key');
      var n = parseInt(lineEl.querySelector('[data-bag-qty-n]').textContent, 10) || 1;
      var next = Math.max(0, Math.min(9, n + parseInt(step.getAttribute('data-bag-qty'), 10)));
      if (next === n) return;
      lineVeil(lineEl, true);
      mutate('/cart/change.js', { id: key, quantity: next }).then(function (res) {
        if (res.ok) { swapFromSections(res.d.sections); netClear(); }
        else { lineVeil(lineEl, false); netFail(function () { refresh(); }); }
      }).catch(function () { lineVeil(lineEl, false); netFail(function () { refresh(); }); });
      return;
    }

    var rem = t.closest('[data-bag-remove]');
    if (rem) {
      var lineEl2 = rem.closest('[data-bag-line]');
      var key2 = lineEl2.getAttribute('data-bag-key');
      lineVeil(lineEl2, true);
      mutate('/cart/change.js', { id: key2, quantity: 0 }).then(function (res) {
        if (res.ok) { swapFromSections(res.d.sections); netClear(); releaseRewardForLine(key2); }
        else { lineVeil(lineEl2, false); netFail(function () { refresh(); }); }
      }).catch(function () { lineVeil(lineEl2, false); netFail(function () { refresh(); }); });
      return;
    }

    var cad = t.closest('[data-bag-cadence]');
    if (cad) {
      var lineEl3 = cad.closest('[data-bag-line]');
      if (cad.getAttribute('aria-expanded') === 'true') closePickers();
      else openPicker(cad, lineEl3);
      return;
    }
    var pickBtn = t.closest('[data-bag-plan-pick]');
    if (pickBtn) {
      var lineEl4 = pickBtn.closest('[data-bag-line]');
      changeCadence(lineEl4, pickBtn.getAttribute('data-bag-plan-pick'));
      return;
    }
    if (!t.closest('.m-bag__picker')) closePickers();
    if (!t.closest('[data-bag-shipon]')) closeShipPickers();

    var sub = t.closest('[data-bag-subscribe]');
    if (sub) {
      var lineEl5 = sub.closest('[data-bag-line]');
      var variant = lineEl5.getAttribute('data-bag-sub-variant');
      var plan = defaultPlan(lineEl5.getAttribute('data-bag-sub-plans'));
      if (variant && plan) convertLine(lineEl5, variant, plan);
      return;
    }
    var once = t.closest('[data-bag-onetime]');
    if (once) {
      var lineEl6 = once.closest('[data-bag-line]');
      var backVariant = lineEl6.getAttribute('data-bag-back-variant');
      if (backVariant) convertLine(lineEl6, backVariant, null);
      return;
    }

    var giftToggle = t.closest('[data-bag-gift-toggle]');
    if (giftToggle) {
      var scope = giftToggle.closest('[data-bag-gift]');
      var on = giftToggle.getAttribute('aria-checked') === 'true';
      if (on) { clearTimeout(giftTimer); giftTimer = null; giftOff(scope); }
      else {
        giftToggle.setAttribute('aria-checked', 'true');
        scope.classList.add('is-on');
        scope.querySelector('[data-bag-gift-fields]').hidden = false;
        scope.querySelector('[data-bag-gift-saved]').hidden = true;
        var toIn = scope.querySelector('[data-bag-gift-to]');
        if (toIn) toIn.focus();
        mutate('/cart/update.js', { attributes: { 'Gift order': 'yes' } }).catch(function () {});
      }
      return;
    }
    var giftEdit = t.closest('[data-bag-gift-edit]');
    if (giftEdit) {
      var scope2 = giftEdit.closest('[data-bag-gift]');
      scope2.querySelector('[data-bag-gift-fields]').hidden = false;
      scope2.querySelector('[data-bag-gift-saved]').hidden = true;
      return;
    }

    var chipX = t.closest('[data-bag-chip-remove]');
    if (chipX) {
      var xcode = chipX.getAttribute('data-bag-chip-remove');
      /* the chip leaves the moment they tap — the cleanup runs behind it */
      var chipNode = chipX.closest('[data-bag-chip], [data-bag-reserved-chip]');
      if (chipNode) chipNode.remove();
      var wasReserved = false;
      try { wasReserved = !!JSON.parse(sessionStorage.getItem('srrco_rw_reserved') || '{}')[String(xcode).toUpperCase()]; } catch (err) {}
      toast(wasReserved ? 'Removed — nothing was spent' : 'Code removed');
      removeCode(xcode);
      /* a reserved drawer pick: cancel the reservation too — no points
         were spent and none will be */
      try {
        var rmap = JSON.parse(sessionStorage.getItem('srrco_rw_reserved') || '{}');
        var rent = rmap[String(xcode).toUpperCase()];
        var rid = rent && typeof rent === 'object' ? rent.id : rent;
        var rbox = document.querySelector('[data-bag-rewards]');
        if (rid && rbox) {
          delete rmap[String(xcode).toUpperCase()];
          sessionStorage.setItem('srrco_rw_reserved', JSON.stringify(rmap));
          fetch(rbox.getAttribute('data-api') + '/shop/rewards/redemption/cancel', {
            method: 'POST', credentials: 'include',
            headers: Object.assign({ 'Content-Type': 'application/json' }, rwHeaders(rbox)),
            body: JSON.stringify({ id: rid })
          }).then(function () { rwMeCache = null; paintDrawerRewards(); paintReservedChips(); }).catch(function () {});
        }
      } catch (err) {}
      return;
    }
    var gcCopy = t.closest('[data-bag-gc-copy]');
    if (gcCopy && gcState.gan) {
      var gan = gcState.gan;
      var done = function () { gcCopy.textContent = 'Copied'; setTimeout(function () { gcCopy.textContent = 'Copy the number'; }, 1600); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(gan).then(done, function () { gcCopy.textContent = gan; });
      else gcCopy.textContent = gan;
      return;
    }
    var gcX = t.closest('[data-bag-gc-remove]');
    if (gcX) {
      gcState.gan = null; gcState.balance = null;
      try { sessionStorage.removeItem(GC_KEY); } catch (e2) {}
      paintGiftCardChip();
      return;
    }

    var shipToggle = t.closest('[data-bag-shipon-toggle]');
    if (shipToggle) {
      var shipBox = shipToggle.closest('[data-bag-shipon]');
      var shipPick = shipBox.querySelector('[data-bag-shipon-picker]');
      var shipWasOpen = shipPick && !shipPick.hidden;
      closeShipPickers();
      if (!shipWasOpen && shipPick) {
        shipCalMonth = null; /* open on the effective ship date's month */
        shipCalRender(shipBox);
        shipPick.hidden = false;
        shipToggle.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    var shipNav = t.closest('[data-bag-shipon-nav]');
    if (shipNav) {
      if (shipNav.disabled) return;
      var navBox = shipNav.closest('[data-bag-shipon]');
      var mStr = shipCalMonth || shipNextBiz().slice(0, 7);
      var navY = parseInt(mStr.slice(0, 4), 10);
      var navM = parseInt(mStr.slice(5, 7), 10) + parseInt(shipNav.getAttribute('data-bag-shipon-nav'), 10);
      if (navM < 1) { navM = 12; navY -= 1; }
      if (navM > 12) { navM = 1; navY += 1; }
      shipCalMonth = String(navY) + '-' + String(navM).padStart(2, '0');
      shipCalRender(navBox);
      return;
    }
    var shipDay = t.closest('[data-bag-shipon-day]');
    if (shipDay) {
      var dayBox = shipDay.closest('[data-bag-shipon]');
      var pickV = shipDay.getAttribute('data-bag-shipon-day') || '';
      if (!shipAllowed(pickV)) { closeShipPickers(); return; }
      var curV = dayBox.getAttribute('data-bag-shipon-value') || '';
      if (pickV === shipNextBiz()) {
        /* the default day: picking it = clearing the attribute (owner:
           ship date never defaults to a stored value) */
        if (curV === '') {
          /* keeping the default after a rules clear answers the note */
          if (shipNote) { shipNote = ''; paintShipRows(); }
          closeShipPickers();
          return;
        }
        setShipDate('');
      } else if (pickV === curV) {
        closeShipPickers();
      } else {
        setShipDate(pickV);
      }
      return;
    }
    var shipReset = t.closest('[data-bag-shipon-reset]');
    if (shipReset) { setShipDate(''); return; }

    var codeApply = t.closest('[data-bag-code-apply]');
    if (codeApply) {
      var box = codeApply.closest('[data-bag-codebox]');
      var input = box && box.querySelector('[data-bag-code]');
      var code = input && input.value.trim();
      if (code) applyCode(code, codeApply);
      return;
    }

    var xadd = t.closest('[data-bag-xsell-add]');
    if (xadd) {
      xadd.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(xadd.getAttribute('data-bag-xsell-add'), 10), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return refresh(); })
        .then(function () { toast('Added · ' + (xadd.getAttribute('data-bag-xsell-name') || 'to your bag')); })
        .catch(function () { xadd.disabled = false; netFail(function () { refresh(); }); });
      return;
    }
  });

  /* gift fields save on blur, counter on input */
  document.addEventListener('input', function (e) {
    if (e.target.closest && e.target.closest('[data-bag-code]') && codeState.text) codeMsg('all', '', false);
    var field = e.target.closest('[data-bag-gift-to], [data-bag-gift-from], [data-bag-gift-msg]');
    if (!field) return;
    var scope = field.closest('[data-bag-gift]');
    var msg = scope.querySelector('[data-bag-gift-msg]');
    var f = giftFieldsOf(scope);
    var lines = msg ? giftLines(msg.value) : 0;
    if (f.count) {
      f.count.textContent = (msg && msg.value ? lines : 0) + ' / ' + GIFT_MAX_LINES + ' lines';
      f.count.classList.toggle('is-over', lines > GIFT_MAX_LINES);
    }
    if (lines > GIFT_MAX_LINES) {
      if (f.over) { f.over.hidden = false; f.over.textContent = 'That\u2019s past ' + GIFT_MAX_LINES + ' printed lines — trim a little and it saves.'; }
      if (msg) msg.classList.add('is-over');
    } else if (f.over) {
      f.over.hidden = true;
      if (msg) msg.classList.remove('is-over');
    }
    /* save as you type, quietly, once the typing pauses */
    clearTimeout(giftTimer);
    giftTimer = setTimeout(function () { giftSave(scope, false); }, 800);
  });
  document.addEventListener('focusout', function (e) {
    var field = e.target.closest('[data-bag-gift-to], [data-bag-gift-from], [data-bag-gift-msg]');
    if (!field) return;
    var scope = field.closest('[data-bag-gift]');
    clearTimeout(giftTimer);
    giftTimer = setTimeout(function () {
      var still = scope.contains(document.activeElement);
      giftSave(scope, !still);
    }, 200);
  });
  /* ship date picks post through the delegated calendar-day clicks above;
     the calendar only renders in-window business days as buttons, and the
     handler re-validates before any post */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab' && isOpen()) {
      if (document.querySelector('.m-choice:not([hidden])')) return; /* chooser popup owns the keyboard */
      var p = panel();
      var list = Array.prototype.filter.call(p.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'), function (el) {
        return !el.disabled && !el.closest('[hidden]') && el.offsetParent !== null;
      });
      if (list.length) {
        var first = list[0], last = list[list.length - 1];
        if (!p.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
        else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    if (e.key === 'Escape') {
      if (document.querySelector('.m-choice:not([hidden])')) return; /* a chooser popup is layered on top */
      if (document.querySelector('.m-bag__picker')) { closePickers(); return; }
      if (closeShipPickers()) return;
      if (isOpen()) closeDrawer();
    }
    if (e.key === 'Enter' && e.target.closest && e.target.closest('[data-bag-code]')) {
      e.preventDefault();
      var box = e.target.closest('[data-bag-codebox]');
      var btn = box && box.querySelector('[data-bag-code-apply]');
      if (btn) btn.click();
    }
  });

  /* the unified bag moved the theme cart (reorder from the account shell,
     bag-page retail edits): re-render our sections */
  document.addEventListener('srrco:bag-cart-synced', function () { refresh(); });
  /* bag state changed (cafe add from m-order, another tab): repaint the
     cafe rail + counts without a section round-trip */
  document.addEventListener('srrco:bag', function () { syncHeaderCount(); });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    try {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
        if (e && e.source === 'external-refresh') refresh();
      });
    } catch (e2) {}
  }

  function paintGiftCounters() {
    document.querySelectorAll('[data-bag-gift]').forEach(function (scope) {
      var msg = scope.querySelector('[data-bag-gift-msg]');
      var count = scope.querySelector('[data-bag-gift-count]');
      if (msg && count) count.textContent = (msg.value ? giftLines(msg.value) : 0) + ' / ' + GIFT_MAX_LINES + ' lines';
    });
  }
  paintGiftCounters();

  syncHeaderCount();
  paintGiftCardChip();
  scrubStaleShip();
  scrubRuleShip();
  paintShipRows();
  poMixCheck(); /* first look: notes the bag as it loaded, never pops */
})();
